
import React from "react";

import './ShareWidget.css';

class ShareWidget extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div id='share'>
                <button onClick={this.props['onscreenshot']}>Take Screenshot</button>
            </div>
        );
    }
}

export default ShareWidget;